<template>
    <section class="technology-certification content-section" ref="ad" id="certification">
        <b-container>
            <b-row>
                <b-col cols="12" md="7">
                    <h2 class="content-section-title">CERTIFICATION</h2>
                    <ul>
                        <li v-for="(item, index) in certs" :key="index">{{item}}</li>
                    </ul>
                    <p class="mb-5">and more ...</p>
                    <p class="subtitle">COUNTLESS CERTIFICATES <br> HAVE WITNESSED OUR COMMITMENTS.</p>
                </b-col>
                <b-col cols="12" md="5" class="certs-gallery">
                    <div 
                        class="certs-gallery-wrap"
                        @mouseenter="mouseenter"
                        @mouseleave="mouseleave"
                    >
                        <div class="certs-gallery-inner">
                            <div class="certs-gallery-right" :class="{isPaused: isPaused}">
                                <div class="certs-gallery-imgwrap" v-for="(img, index) in certImgR" :key="index">
                                    <b-img :src="img" fluid></b-img>
                                </div>
                            </div>
                            <div class="certs-gallery-left" :class="{isPaused: isPaused}">
                                <div class="certs-gallery-imgwrap" v-for="(img, index) in certImgL" :key="index">
                                    <b-img :src="img" fluid></b-img>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            certs:[
                '+ CZZ: GB/T29490-2013',
                '+ Business Social Compliance Initiative',
                '+ IATF16949:2016',
                '+ ISO 14001:2015',
                '+ Germany: Nr.20 2004 012 547.1',
                '+ European: 2781416',
                '+ Russia: 108742',
                '+ United States Patent',
                '+ China: ZL 2013 3 0430457.2',
                '+ Japan: 3151509',
            ],
            certImgR: [],
            certImgL: [],
            isPaused: false
        }
    },
    created() {
        for (let index = 1; index < 12; index++) {
            if( index%2 !== 0){
                this.certImgR.push(require(`@/assets/images/technology/cert_0${index}.jpg`))
            } else{
                this.certImgL.push(require(`@/assets/images/technology/cert_0${index}.jpg`))
            }
        }
        this.certImgR = [...this.certImgR, ...this.certImgR]
        this.certImgL = [...this.certImgL, ...this.certImgL]
    },
    methods: {
        mouseenter() {
            this.isPaused = true
        },
        mouseleave() {
            this.isPaused = false
        }
    },
}
</script>

<style lang="scss">
    .technology-certification{
        color: $color-main-aux;

        .subtitle{
            font-size: 24px;
            letter-spacing: 2px;
            line-height: 1.5;
        }
    }
    .certs-gallery{
        &-wrap{
            position: relative;
            height: 450px;
            overflow: hidden;
        }
        &-inner{
            display: flex;
            flex-wrap: wrap;
        }
        &-right,
        &-left {
            width: 50%;
            padding: 0 10px;
            transition: transform 1s cubic-bezier(.19,1,.22,1);
            animation: a 30s linear infinite;
        }
        &-right{
            margin-top: -28%;
        }
        &-imgwrap{
            padding: 2px;
            margin: 20px 0;
            border:1px solid #eee;
            box-shadow: 0px 0px 2px #999;
            border-radius: 2px;
            overflow: hidden;
            transition: transform 1s cubic-bezier(.19,1,.22,1);

            &:hover {
                transform: scale(1.08);
                img{
                    transform: scale(1);
                }
            }

            img{
                transform: scale(1.05);
                transition: transform 1.3s cubic-bezier(.19,1,.22,1)
            }
        }
    }
    .isPaused{
        animation-play-state: paused
    }
    @keyframes a {
        0% {
            tranform: translateY(0)
        }

        to {
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%)
        }
    }
</style>